<template>
    <div class="page-box">
      <Header/>
      <div class="mg-bottom-70 bg-color-EAF1FA">
        <TopBanner :top-banner-img="BannerImg" title2="全渠道电商ERP" title-row1="是电商行业适应多渠道销售" :titleStyle="{fontSize: '32px',lineHeight: '45px'}" :tipsFlex="true" :special="true" :title-tips-list="titleTipsList" :contentStype="{paddingTop: '170px'}">
          <div class="top-banner-tips">
            支持传统平台电商、直播电商、跨境电商、社群电商、自营平台等业务模式线上线下、<br/>跨平台、多店铺订单/库存/履约售后/财务等统一管理，帮助企业实现资源的高效分配<br/>和使用，提升运营效率，增强市场竞争力
          </div>
        </TopBanner>
      </div>
      <!-- 经营痛点 -->
      <div class="mg-bottom-100">
        <ModuleTitle data-aos="fade-up" bg-color="#fff" title="经营痛点" :moduleTipsList="[{name: '使用传统ERP进行进销存管理的商家，在各个销售渠道上的业务流程，面临多重挑战'}]" />
        <ModuleCenter >
            <div class="flex-box" data-aos="fade-up">
              <CardItem v-for="(item, index) in painList" :key="index" :item="item" :cardStyle="painCardStyle"></CardItem>
            </div>
        </ModuleCenter>
      </div>
      <!-- 错单漏单不再有，降本增效不再愁 -->
      <div class="barrier-background pd-top-70" style="height: 760px;background-color: #F4F5FB">
          <ModuleTitle data-aos="fade-up" title="错单漏单不再有，降本增效不再愁" />
          <ModuleCenter >
            <div class="flex-box" data-aos="fade-up">
              <div class="img-card-item">
                <img class="img-card-img" src="@/assets/product/digitalSystem/img-card-1.png" alt="" />
                <div class="img-card-content">
                  <div class="img-card-title">多店铺、多平台、来回切换、人工忙不过来、还总出错？</div>
                  <div>
                    <div class="img-card--ilne">
                      <img class="img-card-icon" :src="CancelImg" alt="">
                      <div class="img-card-desc">全平台、多店铺、不限账号、统一管理</div>
                    </div>
                    <div class="img-card--ilne">
                      <img class="img-card-icon" :src="CancelImg" alt="">
                      <div class="img-card-desc">客服助手快速管理多平台客户咨询，及时更新迭代适应平台变化</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img-card-item">
                <img class="img-card-img" src="@/assets/product/digitalSystem/img-card-2.png" alt="" />
                <div class="img-card-content">
                  <div class="img-card-title">订单积压、发货慢、错单漏单、售后处理流程复杂？</div>
                  <div>
                    <div class="img-card--ilne">
                      <img class="img-card-icon" :src="CancelImg" alt="">
                      <div class="img-card-desc">多平台自动抓取订单</div>
                    </div>
                    <div class="img-card--ilne">
                      <img class="img-card-icon" :src="CancelImg" alt="">
                      <div class="img-card-desc">自动审单、打单、验货、出库一体化，同步订单备注，智能退换一键处理</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img-card-item">
                <img class="img-card-img" src="@/assets/product/digitalSystem/img-card-3.png" alt="" />
                <div class="img-card-content">
                  <div class="img-card-title">定期盘点数据不准，报表难以发现问题、不能捕捉商机？</div>
                  <div>
                    <div class="img-card--ilne">
                      <img class="img-card-icon" :src="CancelImg" alt="">
                      <div class="img-card-desc">数据异常预警，警戒库存设置</div>
                    </div>
                    <div class="img-card--ilne">
                      <img class="img-card-icon" :src="CancelImg" alt="">
                      <div class="img-card-desc">畅销品分析，滞销品分析，各种明细报表一应俱全</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img-card-item">
                <img class="img-card-img" src="@/assets/product/digitalSystem/img-card-4.png" alt="" />
                <div class="img-card-content">
                  <div class="img-card-title">库存同步不准确？不是超额采购就是库存不足？</div>
                  <div>
                    <div class="img-card--ilne">
                      <img class="img-card-icon" :src="CancelImg" alt="">
                      <div class="img-card-desc">基于商家库存及进货情况开启库存同步策略</div>
                    </div>
                    <div class="img-card--ilne">
                      <img class="img-card-icon" :src="CancelImg" alt="">
                      <div class="img-card-desc">库存自动实时同步，避免超卖，并为采购进货提供依据</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModuleCenter>
      </div>
      <div class="barrier-background pd-top-70" style="height: 910px;">
        <ModuleTitle data-aos="fade-up" title="链路闭环全打通，支持快速上线+定制化需求满足" :moduleTipsList="[{name: '功能板块全景：承上启下，支持新渠道/新品牌扩展，以及供应链能力延伸'}]" />
        <ModuleCenter >
          <img data-aos="fade-up" class="width-1200-img" src="@/assets/product/digitalSystem/onlineErp-1.png" alt="">
        </ModuleCenter>
      </div>
      <div class="barrier-background pd-top-120" style="height: 1050px;">
        <ModuleTitle data-aos="fade-up" title="功能更强大，操作更轻松" />
        <ModuleCenter >
          <img data-aos="fade-up" class="width-1200-img" src="@/assets/product/digitalSystem/onlineErp-2.png" alt="">
        </ModuleCenter>
      </div>
      <!-- 商品管理 -->
      <div class="goods-manage pd-bottom-100" style="margin-top: 150px;">
        <ModuleTitle data-aos="fade-up" title="订单处理快准强，系统稳定有保障" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-left goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">订单处理快</span>
                  <div>标准查询仅需0.04s，订单处理峰值达16.455万单每秒，从审单至发货快至5秒</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">运营策略强</span>
                  <div>多种订单执行策略，消息策略，回访策略，物流策略</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">系统运行稳</span>
                  <div>历年双11大促期间，系统0宕机、0卡顿、0漏单</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" src="@/assets/product/digitalSystem/onlineErp-3.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">数据统计准</span>
                  <div>精细到仓到SKU的成本管理，按使用者岗位设置的分析，精准剖析人员绩效</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">信息保安全</span>
                  <div>SAAS系统，传输过程中数据加密验证身份，分岗位设权限</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">售后有保障</span>
                  <div>标准化实施流程，全生命周期管家式服务，大促保障免卡顿，免脱机，免投诉</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <Footer/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TopBanner from './components/topBanner.vue'
import Banner from '@/assets/product/digitalSystem/banner-5.jpg'
import ModuleTitle from './components/moduleTitle.vue'
import ModuleCenter from './components/moduleCenter.vue'
import CardItem from './components/cardItem.vue'
import IMBanner1 from '@/assets/product/digitalSystem/integration-module-banner-1.png'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
import ModuleBgBlue from './components/moduleBgBlue.vue'
import OneStopBanner from '@/assets/product/digitalSystem/One-Stop-banner.png'
import SimpleCance from '@/assets/home/check.svg'
import imgText1 from '@/assets/product/digitalSystem/img-text-1.png'
import BgBlue from '@/assets/product/bg-blue.png'
export default {
  components: {
    Header,
    Footer,
    TopBanner,
    ModuleTitle,
    ModuleCenter,
    CardItem,
    IMBanner1,
    ModuleBgBlue
  },
   data() {
      return {
        CancelImg: Cancel,
        BgBlue: BgBlue,
        imgText1: imgText1,
        BannerImg: Banner,
        titleTipsList: [
          {
            name: '电商平台卖家'
          },
          {
            name: '跨境卖家'
          }
        ],
        painList: [
          {
            icon: require("@/assets/product/svgIcon/pain-spot-13.svg"),
            name: '无法寻源',
            imgShow: false,
            descList: [
              '订单无法有效寻源，人工派发工作量大，容易出错',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-10.svg"),
            name: '售后处理不及时',
            imgShow: false,
            descList: [
              '用户退货退款时效长，无法满足线上平台要求，容易被平台方触发',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-4.svg"),
            name: '灵活性不足',
            imgShow: false,
            descList: [
              '做数字化转型，针对线上交易多变和时效性，流程繁琐笨重',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-8.svg"),
            name: '多渠道支持',
            imgShow: false,
            descList: [
              '面对多平台销售，需要大量重复的商品维护、订单补录等重复性线下工作',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-2.svg"),
            name: '库存更新不及时',
            imgShow: false,
            descList: [
              '与上游供货商离线协同，难以做到多渠道一盘货管理',
            ]
          }
        ],
        cardStyle: {
          width: '224px',
          height: '220px',
          padding: '30px 20px 0 20px',
          marginBottom: '0px'
        },
        serviceabilityList: [
          {
            icon: require("@/assets/product/svgIcon/core-advantages-6.svg"),
            name: '全域获客',
            imgShow: false,
            descList: [
              '会员价值模型及有效的触达体系，基于用户旅程构建完整的全域触点连接方案实现海量且长效的用户获取',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-7.svg"),
            name: '傻瓜式运营',
            imgShow: false,
            descList: [
              '提供丰富的运营素材（包含图片、视频等），适配各种行业的页面模板，可快速、无门槛的运营',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-5.svg"),
            name: '多模式运营',
            imgShow: false,
            descList: [
              '支持商家入驻+平台自营多种运营模式，入驻服务年费、商品销售佣金等多种盈利方式',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-6.svg"),
            name: '定向营销',
            imgShow: false,
            descList: [
              '基于用户个体需求，实行千人千策营销策路，为每个用户提供所需且极致的用户体验',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-8.svg"),
            name: '商品上架',
            imgShow: false,
            descList: [
              '灵活的产品参数，全行业产品支持、特别是对于工业配件以及工业品多参数的用户筛选和销售上，灵活设置',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-9.svg"),
            name: '全息洞察',
            imgShow: false,
            descList: [
              '设定标签体系，构建用户全渠道画像布局，实现可实时感知的用户需求及用户资产沉淀',
            ]
          }
        ],
        serviceabilityStyle: {
          width: '380px',
          height: '210px',
          padding: '30px 40px 0 40px',
          marginBottom: '30px'
        },
        CarouselList: [{
          url: require('@/assets/product/digitalSystem/carousel-1.png'),
        },{
          url: require('@/assets/product/digitalSystem/carousel-2.png'),
        },{
          url: require('@/assets/product/digitalSystem/carousel-3.png'),
        }],
        painCardStyle: {
          width: '224px',
          height: '210px',
          padding: '30px 20px 0 20px',
          marginBottom: '0px'
        },
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.page-box {
  background-color: #fff;
}
.bg-color-EAF1FA {
  background-color: #EAF1FA;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.top-banner-tips{
  font-size: 16px;
  color: #222222;
  line-height: 28px;
  margin-bottom: 24px;
  width: 638px;
}
.mg-bottom-70 {
  margin-bottom: 70px;
}
/* 图文导航 */
.image-text-item {
  display: flex;
}
.image-text-item-left {
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  width: 468px;
  height: 220px;
  text-align: left;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  padding: 37px 0 0 30px;
  margin-right: 20px;
}
.title-text {
  font-weight: bold;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 32px;
}
.pd-bottom-90 {
  padding-bottom: 90px;
}
/* 零售商城具备完善的服务能力 */
.barrier-background {
  width: 100%;
  min-width: 1200px;
  background-repeat: no-repeat;
  background-size: 1920px 100%;
  background-position: center;
}
.pd-top-70 {
  padding-top: 70px;
}
/* 会员体系打造 等级成长持续活跃 */
.active-item {
  width: 580px;
  height: 430px;
  background: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
  padding: 40px 40px 0 40px;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
.active-item-title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.active-item-img {
  width: 500px;
  height: 280px;
  margin-top: 30px;
}
.border-shadow {
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
}
/* 一键美化，轻松运营！打造专属您的线上商城！ */
.Carousel-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}
.Carousel-item-title {
  font-size: 24px;
  color: #222222;
  line-height: 46px;
  margin-bottom: 50px;
}
.mg-bottom-50 {
  margin-bottom: 50px;
}
.Carousel-right, .Carousel-img {
  width: 650px;
  height: 550px;
}
.pd-bottom-100 {
  padding-bottom: 100px;
}
.mg-bottom-100{
  margin-bottom: 100px;
}
/* 错单漏单不再有，降本增效不再愁 */
.img-card-item {
  width: 580px;
  height: 230px;
  position: relative;
  padding-left: 50px;
  text-align: left;
  margin-bottom: 40px;
}
.img-card-img {
  width: 200px;
  height: 160px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.img-card-content {
  width: 530px;
  height: 230px;
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
  padding: 30px 0px 0 180px;
}
.img-card-title {
  width: 300px;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 30px;
  margin-bottom: 24px;
}
.img-card--ilne {
  display: flex;
  margin-bottom: 16px;
}
.img-card-icon {
  width: 17px;
  height: 12px;
  margin-right: 8px;
}
.img-card-desc {
  width: 270px;
  font-size: 14px;
  color: #222222;
  line-height: 20px;
}
.width-1200-img {
  width: 1200px;
  height: auto;
}
.pd-top-120 {
  padding-top: 120px;
}
/* 订单处理快准强，系统稳定有保障 */
.goods-manage-ilne {
  display: flex;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
.item-ilne-icon {
  width: 22px;
  height: 16px;
  margin-right: 10px;
}
.item-ilne-title {
  display: inline-block;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.item-ilne-content {
  width: 250px;
}
.goods-manage-mid-img {
  width: 520px;
  height: 480px;
}
.goods-manage-item {
  box-sizing: border-box;
  height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 53px 0;
}
</style>
